/**
 * UK → US shipping from cart weight. Refreshes all shipping UI on the page.
 *
 * Formula (matches main-cart.liquid + catalog weight_kg on Shopify):
 *   unit_g  = variant.grams from Shopify Admin (never product title)
 *   line_g  = unit_g × qty
 *   cart_g  = sum(line_g) excluding lb-order-margin fee lines
 *   shipping = rate_card(cart_g).customerUsd
 *   order_total = product_subtotal + shipping
 */
(function (global) {
  var ratesPromise = null;
  var DEFAULT_RATES = {
    gbpToUsd: 1.27,
    bands: [
      { minKg: 0, maxKg: 2, service: "International Tracked", totalGbp: 8.18, customerUsd: 14.99 },
      { minKg: 2, maxKg: 5, service: "International Tracked", totalGbp: 12.53, customerUsd: 19.99 },
      { minKg: 5, maxKg: 6, service: "International Tracked", totalGbp: 24.64, customerUsd: 34.99 },
      { minKg: 6, maxKg: 7, service: "International Tracked", totalGbp: 28.03, customerUsd: 39.99 },
      { minKg: 7, maxKg: 8, service: "International Tracked", totalGbp: 31.65, customerUsd: 44.99 },
      { minKg: 8, maxKg: 9, service: "International Tracked", totalGbp: 35.91, customerUsd: 49.99 },
      { minKg: 9, maxKg: 10, service: "International Tracked", totalGbp: 41.06, customerUsd: 54.99 },
      { minKg: 10, maxKg: 15, service: "International Tracked", totalGbp: 42.16, customerUsd: 59.99 },
      { minKg: 15, maxKg: 20, service: "International Tracked", totalGbp: 54.66, customerUsd: 74.99 },
      { minKg: 20, maxKg: 25, service: "International Tracked", totalGbp: 71.82, customerUsd: 94.99 },
      { minKg: 25, maxKg: 9999, service: "International Tracked", totalGbp: 85.43, customerUsd: 114.99 },
    ],
  };

  function routesRoot() {
    return (global.Shopify && global.Shopify.routes && global.Shopify.routes.root) || "/";
  }

  function embeddedRates() {
    var bands = global.lbShippingBands;
    if (bands && bands.length) {
      return { gbpToUsd: 1.27, bands: bands };
    }
    return null;
  }

  function loadRates() {
    var embedded = embeddedRates();
    if (embedded) {
      return Promise.resolve(embedded);
    }
    if (!ratesPromise) {
      var url =
        (global.lbUkUsShippingRatesUrl || "").trim() ||
        routesRoot() + "assets/uk-us-shipping-rates.json";
      ratesPromise = fetch(url)
        .then(function (r) {
          if (!r.ok) throw new Error("rates fetch failed");
          return r.json();
        })
        .then(function (data) {
          if (!data || !data.bands || !data.bands.length) return DEFAULT_RATES;
          if (!data.bands[0].customerUsd) return DEFAULT_RATES;
          return data;
        })
        .catch(function () {
          return DEFAULT_RATES;
        });
    }
    return ratesPromise;
  }

  function round2(n) {
    return Math.round(n * 100) / 100;
  }

  function embeddedCartWeightGrams() {
    var summary = document.getElementById("lb-cart-summary");
    if (!summary) return 0;
    return parseInt(summary.getAttribute("data-weight-grams"), 10) || 0;
  }

  var MIN_UNIT_GRAMS = 200;
  var TEST_HANDLE = "lb-test-purchase";

  function isTestHandle(handle) {
    return String(handle || "").trim() === TEST_HANDLE;
  }

  function cartIsTestOnly(cart) {
    if (!cart || !Array.isArray(cart.items) || !cart.items.length) return false;
    var productLines = (cart.items || []).filter(function (item) {
      return !isFeeItem(item);
    });
    if (!productLines.length) return false;
    return productLines.every(function (item) {
      return isTestHandle(item.handle || item.product_handle || "");
    });
  }

  function isFeeItem(item) {
    if (window.LbRemoveFee && window.LbRemoveFee.isFeeItem) {
      return window.LbRemoveFee.isFeeItem(item);
    }
    return item && item.product_handle === "lb-order-margin";
  }

  function findCartLineForItem(item) {
    if (!item) return null;
    var form = document.getElementById("cart-form");
    if (!form) return null;
    if (item.key) {
      var byKey = form.querySelector('.lb-cart-line[data-line-key="' + item.key + '"]');
      if (byKey) return byKey;
    }
    if (item.variant_id) {
      return form.querySelector('.lb-cart-line[data-variant-id="' + item.variant_id + '"]');
    }
    return null;
  }

  function unitGramsFromDom(item) {
    var line = findCartLineForItem(item);
    if (!line) return 0;
    return parseInt(line.getAttribute("data-unit-weight-grams"), 10) || 0;
  }

  function lineQtyFromDom(item, fallbackQty) {
    var line = findCartLineForItem(item);
    if (!line) return Math.max(1, parseInt(fallbackQty, 10) || 1);
    var input = line.querySelector("input[data-line-key]");
    var qty = input ? parseInt(input.value, 10) : parseInt(fallbackQty, 10);
    return Math.max(1, qty || 1);
  }

  /** Per-unit grams from Shopify Admin variant weight (DOM or cart.js). Never parse titles. */
  function perUnitGramsFromItem(item) {
    var fromDom = unitGramsFromDom(item);
    if (fromDom >= MIN_UNIT_GRAMS) return fromDom;

    var qty = Math.max(1, parseInt(item && item.quantity, 10) || 1);
    var fromCart = parseInt(item && item.grams, 10) || 0;
    if (fromCart > 0) {
      if (qty > 1) {
        var perFromLine = Math.round(fromCart / qty);
        if (perFromLine >= MIN_UNIT_GRAMS) {
          return perFromLine;
        }
      }
      return normalizeUnitGrams(fromCart);
    }

    return MIN_UNIT_GRAMS;
  }

  function unitGramsFromCartItem(item) {
    return perUnitGramsFromItem(item);
  }

  /** Line total grams = unit weight × quantity (count once). */
  function lineWeightGrams(item) {
    var qty = Math.max(1, lineQtyFromDom(item, item && item.quantity));
    return perUnitGramsFromItem(item) * qty;
  }

  function productUnitsInCart(cart) {
    var n = 0;
    (cart.items || []).forEach(function (item) {
      if (isFeeItem(item)) return;
      n += item.quantity || 1;
    });
    return n;
  }

  function lineUnitGramsFromDom(line) {
    return normalizeUnitGrams(
      parseInt(line.getAttribute("data-unit-weight-grams"), 10) || 0
    );
  }

  /** Sum of (unit_g × qty) for all product lines on cart page. */
  function cartWeightGramsFromDom() {
    var form = document.getElementById("cart-form");
    if (!form) return 0;
    var grams = 0;
    form.querySelectorAll(".lb-cart-line").forEach(function (line) {
      var perUnit = lineUnitGramsFromDom(line);
      var input = line.querySelector('input[data-line-key]');
      var qty = input ? Math.max(1, parseInt(input.value, 10) || 1) : 1;
      grams += perUnit * qty;
    });
    return grams;
  }

  function cartWeightGrams(cart) {
    var domGrams = cartWeightGramsFromDom();
    if (domGrams > 0) return domGrams;

    var grams = 0;
    (cart.items || []).forEach(function (item) {
      if (isFeeItem(item)) return;
      grams += lineWeightGrams(item);
    });
    if (grams < 1) {
      var units = productUnitsInCart(cart);
      if (units > 0) grams = MIN_UNIT_GRAMS * units;
    }
    return grams;
  }

  function pickBandForGrams(g, bands) {
    var sorted = (bands || DEFAULT_RATES.bands).slice().sort(function (a, b) {
      return Number(a.minKg) - Number(b.minKg);
    });
    var i;
    for (i = 0; i < sorted.length; i += 1) {
      var b = sorted[i];
      var minG = Math.round(Number(b.minKg) * 1000);
      var maxG =
        Number(b.maxKg) >= 9999
          ? 2147483647
          : Math.round(Number(b.maxKg) * 1000);
      if (Number(b.minKg) === 0 && g < maxG) return b;
      if (g >= minG && g <= maxG) return b;
    }
    return sorted[sorted.length - 1] || null;
  }

  function quoteGrams(grams, data) {
    var g = Math.max(1, Math.round(Number(grams) || 200));
    var bands = (data && data.bands) || DEFAULT_RATES.bands;
    var band = pickBandForGrams(g, bands);
    if (!band) return null;
    var fx = Number(data && data.gbpToUsd) || 1.27;
    var usd =
      band.customerUsd > 0
        ? Number(band.customerUsd)
        : round2(band.totalGbp * fx);
    return {
      weightGrams: g,
      weightKg: round2(g / 1000),
      totalGbp: band.totalGbp,
      totalUsd: round2(usd),
      service: band.service,
      bandLabel:
        band.maxKg >= 9999
          ? band.minKg + "+ kg"
          : band.minKg + "–" + band.maxKg + " kg",
    };
  }

  function quote(weightKg, data) {
    var g = Math.max(1, Math.round((Number(weightKg) || 0.2) * 1000));
    return quoteGrams(g, data);
  }

  function normalizeUnitGrams(grams) {
    var g = parseInt(grams, 10) || 0;
    return g < MIN_UNIT_GRAMS ? MIN_UNIT_GRAMS : g;
  }

  function shippingCentsForGrams(grams, data) {
    var rates = data || embeddedRates() || DEFAULT_RATES;
    var g = Math.max(1, Math.round(Number(grams) || 0));
    var q = quoteGrams(g, rates);
    if (!q || !(q.totalUsd > 0)) {
      q = quoteGrams(g, DEFAULT_RATES);
    }
    if (!q || !(q.totalUsd > 0)) return 0;
    return Math.round(q.totalUsd * 100);
  }

  function shippingCentsForCart(cart) {
    if (!cart || !cart.item_count) return 0;
    if (cartIsTestOnly(cart)) return 0;
    return shippingCentsForGrams(cartWeightGrams(cart), embeddedRates() || DEFAULT_RATES);
  }

  var refreshSeq = 0;
  var cachedCart = null;

  function cartGramsForProductPreview(cart) {
    if (cart && cart.item_count) return cartWeightGrams(cart);
    return 0;
  }

  function ratesDataSync() {
    return embeddedRates() || DEFAULT_RATES;
  }

  function lineWeightGramsForQty(unitGrams, qty) {
    return normalizeUnitGrams(unitGrams) * Math.max(1, parseInt(qty, 10) || 1);
  }

  function formatMoneyUsd(amount) {
    if (global.Shopify && typeof global.Shopify.formatMoney === "function") {
      return global.Shopify.formatMoney(
        Math.round(Number(amount) * 100),
        global.Shopify.money_format || "${{amount}}"
      );
    }
    return "$" + Number(amount).toFixed(2);
  }

  function formatMoneyCents(cents) {
    if (global.Shopify && typeof global.Shopify.formatMoney === "function") {
      return global.Shopify.formatMoney(
        cents,
        global.Shopify.money_format || "${{amount}}"
      );
    }
    return "$" + (Number(cents) / 100).toFixed(2);
  }

  function renderQuoteHtml(q, opts) {
    opts = opts || {};
    var prefix = opts.prefix || "Shipping";
    return (
      '<p class="lb-shipping-estimate__main">' +
      "<strong>" +
      prefix +
      ":</strong> " +
      formatMoneyUsd(q.totalUsd) +
      ' <span class="lb-shipping-estimate__meta">(' +
      q.weightKg +
      " kg · " +
      q.bandLabel +
      ")</span></p>" +
      '<p class="lb-shipping-estimate__detail">' +
      (q.service || "International Tracked") +
      " · tracked</p>"
    );
  }

  function setHtml(id, html, show) {
    var el = document.getElementById(id);
    if (!el) return;
    if (show === false || !html) {
      el.hidden = true;
      return;
    }
    el.hidden = false;
    el.innerHTML = html;
  }

  function headerCartUnits(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    var units = 0;
    cart.items.forEach(function (item) {
      if (!item) return;
      if (window.LbRemoveFee && typeof window.LbRemoveFee.isFeeItem === "function") {
        if (window.LbRemoveFee.isFeeItem(item)) return;
      } else if (String(item.handle || item.product_handle || "").trim() === "lb-order-margin") {
        return;
      }
      units += item.quantity || 0;
    });
    return units;
  }

  function updateHeaderCartCount(cart) {
    var countEl = document.getElementById("lb-header-cart-count");
    if (!countEl || !cart) return;
    var units = headerCartUnits(cart);
    countEl.textContent = String(units);
    var cartLink = countEl.closest(".lb-header-cart");
    if (cartLink) cartLink.setAttribute("aria-label", "Cart, " + units + " items");
  }

  function updateHeader(cart, q) {
    updateHeaderCartCount(cart);

    var bar = document.getElementById("lb-live-shipping");
    if (!bar) return;

    var units = headerCartUnits(cart);
    if (!units || !cart || !cart.item_count) {
      bar.hidden = true;
      return;
    }

    var grams = cartWeightGrams(cart);
    var shipCents = shippingCentsForGrams(grams);
    if (shipCents < 1) shipCents = 1499;
    var weightKg = round2(grams / 1000);
    var shipUsd = shipCents / 100;
    var productCents = bulkProductCents(cart);

    bar.hidden = false;
    var weightEl = document.getElementById("lb-live-shipping-weight");
    var shipEl = document.getElementById("lb-live-shipping-price");
    var totalEl = document.getElementById("lb-live-shipping-grand");
    if (weightEl) weightEl.textContent = weightKg + " kg";
    if (shipEl) shipEl.textContent = formatMoneyUsd(shipUsd);
    if (totalEl) {
      totalEl.textContent = formatMoneyCents(productCents + shipCents);
    }
    var countBar = bar.querySelector(".lb-live-shipping__count");
    if (countBar) countBar.textContent = String(units);
  }

  function bulkProductCents(cart) {
    if (window.LbCartSummary && typeof window.LbCartSummary.bulkTotals === "function") {
      var t = window.LbCartSummary.bulkTotals(cart);
      if (cart.total_discount > 0 && cart.total_price > 0) return cart.total_price;
      return t.bulkCents;
    }
    return cart.total_price || 0;
  }

  function updateCartPage(cart) {
    var summary = document.getElementById("lb-cart-summary");
    var grams = cartWeightGrams(cart);
    if (summary && cart.item_count) {
      summary.setAttribute("data-weight-grams", String(grams));
    }
    if (window.LbCartSummary && typeof window.LbCartSummary.updateCartSummary === "function") {
      window.LbCartSummary.updateCartSummary(cart);
      return;
    }

    var productCents = bulkProductCents(cart);
    var shipCents = cart.item_count ? shippingCentsForGrams(grams) : 0;
    if (shipCents < 1) shipCents = 1499;
    var weightEl = document.getElementById("lb-cart-weight-total");
    if (weightEl && grams > 0) {
      weightEl.textContent = (Math.round(grams) / 1000).toFixed(2) + " kg";
    }
    var shipEl = document.getElementById("lb-cart-shipping-total");
    if (shipEl) {
      shipEl.textContent = formatMoneyCents(shipCents > 0 ? shipCents : 1499);
    }
    if (summary) {
      summary.setAttribute("data-shipping-cents", String(shipCents));
    }
    var grandEl = document.getElementById("lb-cart-grand-total");
    if (grandEl) {
      grandEl.textContent = formatMoneyCents(productCents + shipCents);
    }
  }

  function updateProductPage() {
    /* Static copy in lb-shipping-estimate.liquid — cart-weight shipping shown at checkout. */
  }

  function refreshCart(cartOptional) {
    var seq = ++refreshSeq;
    var cartPromise = cartOptional
      ? Promise.resolve(cartOptional)
      : fetch(routesRoot() + "cart.js").then(function (r) {
          return r.json();
        });

    return cartPromise
      .then(function (cart) {
        if (seq !== refreshSeq) return null;
        cachedCart = cart;
        var grams = cartWeightGrams(cart);
        var weightKg = grams / 1000;
        return loadRates().then(function (data) {
          if (seq !== refreshSeq) return null;
          var q = cart.item_count > 0 ? quoteGrams(grams, data) : null;
          updateHeader(cart, q);
          updateCartPage(cart);
          updateProductPage(cart);
          document.dispatchEvent(
            new CustomEvent("lb:shipping-updated", {
              detail: { cart: cart, quote: q, weightKg: weightKg, weightGrams: grams },
            })
          );
          return { cart: cart, quote: q };
        });
      })
      .catch(function () {
        return null;
      });
  }

  function initProductQty() {
    var qtyInput = document.getElementById("quantity");
    if (!qtyInput) return;
    function onQty() {
      if (window.LbBulkPricing && typeof window.LbBulkPricing.updateTotals === "function") {
        window.LbBulkPricing.updateTotals();
      }
    }
    qtyInput.addEventListener("change", onQty);
    qtyInput.addEventListener("input", onQty);
  }

  global.LbUkUsShipping = {
    MIN_UNIT_GRAMS: MIN_UNIT_GRAMS,
    loadRates: loadRates,
    quote: quote,
    quoteGrams: quoteGrams,
    pickBandForGrams: pickBandForGrams,
    shippingCentsForGrams: shippingCentsForGrams,
    shippingCentsForCart: shippingCentsForCart,
    lineWeightGramsForQty: lineWeightGramsForQty,
    normalizeUnitGrams: normalizeUnitGrams,
    cartWeightGrams: cartWeightGrams,
    formatMoneyUsd: formatMoneyUsd,
    refreshCart: refreshCart,
    updateProductPage: updateProductPage,
    updateHeaderCartCount: updateHeaderCartCount,
    headerCartUnits: headerCartUnits,
    renderQuoteHtml: renderQuoteHtml,
  };

  document.addEventListener("DOMContentLoaded", function () {
    initProductQty();
    refreshCart();
  });

  document.addEventListener("lb:cart-updated", function (e) {
    refreshCart(e.detail && e.detail.cart);
  });
})(typeof window !== "undefined" ? window : globalThis);
